// Reenvíos acotados de una cola existente. Este controlador nunca captura estadísticas.
export function createDataUsageRecovery({ upload, schedule = setTimeout, cancel = clearTimeout }) {
    let disposed = false, running = null, timer = null, attempts = 0;
    const run = () => {
        if (disposed) return Promise.resolve();
        if (running) return running;
        cancel(timer); timer = null;
        running = Promise.resolve().then(upload).then(result => {
            if (!disposed && result?.pending && result.retryable && attempts < 3) {
                timer = schedule(() => { attempts++; void run(); }, [1500, 5000, 15000][attempts]);
            }
            return result;
        }).catch(() => null).finally(() => { running = null; });
        return running;
    };
    return {
        recover() { attempts = 0; return run(); },
        dispose() { disposed = true; cancel(timer); timer = null; },
    };
}
